// Importing necessary libraries and components
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import { makeStyles } from "@material-ui/core/styles";
import { getAgentByHierarchy } from "../../Redux/Actions/ProvideRegistration";

// Custom styles for the component
const useStyles = makeStyles(styles);

// Functional component for Agent Search with autocomplete
function AgentSearchChip(props) {
  const classes = useStyles();
  const { clearSearchManagerName } = props; // Prop to clear the search manager name
  const [searchManagerName, setSearchManagerName] = React.useState(""); // State to store the search manager name

  // Set to ensure unique managers
  const uniqueManagerSet = new Set();

  // Extracting unique managers from merchant data
  const uniqueManagers = (props.merchantData?.merchantListNames?.data || [])
    .map(manager => ({
      name: `${manager?.Manager_Details?.First_Name || ""} ${manager?.Manager_Details?.Last_Name || ""}`,
      email: manager?.Manager_Details?.Email || "",
      id: manager?._id || "",
    }))
    .filter(manager => {
      if (uniqueManagerSet.has(manager.email)) {
        return false; // Skip duplicate emails
      }
      uniqueManagerSet.add(manager.email);
      return true; // Add unique manager
    });

  const { setParentSearchManagerId, setParentSearchManagerName, propsf } = props;

  // Function to handle changes in the search manager name
  const handleSearchManagerNameChange = value => {
    setSearchManagerName(value ? `${value.name} [${value.email}]` : "");
    setParentSearchManagerName(value ? `${value.name} [${value.email}]` : "");
    setParentSearchManagerId(value ? value.id : "");
  };

  const selectedValue = propsf || searchManagerName;

  const selectedManager =
    uniqueManagers.find(manager => {
      if (!selectedValue) {
        return false;
      }

      if (typeof selectedValue === "object" && selectedValue !== null) {
        return manager.id === selectedValue.id;
      }

      return (
        manager.name === selectedValue ||
        manager.email === selectedValue ||
        `${manager.name} [${manager.email}]` === selectedValue
      );
    }) || null;

  // Rendering the autocomplete component
  return (
    (propsf || searchManagerName
      ? (
        <Autocomplete
          value={selectedManager} // Pre-filled value
          name="searchManagerName"
          id="searchManagerName"
          className={classes.rootDialog}
          onChange={(event, value, reason) => {
            handleSearchManagerNameChange(value);
            if (reason === "clear") {
              clearSearchManagerName();
            }
          }}
          options={uniqueManagers} // Options for autocomplete
          clearOnBlur
          clearOnEscape
          getOptionLabel={option => option ? `${option.name || ""} [${option.email || ""}]` : ""}
          getOptionSelected={(option, value) => option.id === value.id}
          // onClear={clearSearchManagerName} // Clear function
          renderOption={option => (
            <div>
              {option.name}
              {" "}
              <span style={{ fontSize: "13px", color: "rgb(121, 68, 17)" }}>
                [
                {option.email}
                ]
              </span>
            </div>
          )}
          ListboxProps={{
            style: {
              maxHeight: 200, // Maximum height for the dropdown
              fontSize: "15px", // Font size for options
            },
          }}
          renderInput={params => (
            <TextField
              {...params}
              style={{ fontSize: "82%" }}
              name="searchManagerName"
              id="searchManagerName"
              label="Manager Name/Email" // Input label
            />
          )}
          label="Manager Name/Email" // Input label
        />
      ) : (
        <Autocomplete
          name="searchManagerName"
          id="searchManagerName"
          className={classes.rootDialog}
          value={selectedManager}
          onChange={(event, value, reason) => {
            handleSearchManagerNameChange(value);

            if (reason === "clear") {
              clearSearchManagerName();
            }
          }}
          options={uniqueManagers} // Options for autocomplete
          clearOnBlur
          clearOnEscape
          getOptionLabel={option => option ? `${option.name || ""} ${option.email || ""}` : ""}
          getOptionSelected={(option, value) => option.id === value.id}
          // onClear={clearSearchManagerName} // Clear function
          renderOption={option => (
            <div>
              {option.name}
              {" "}
              <span style={{ fontSize: "13px", color: "rgb(121, 68, 17)" }}>
                [
                {option.email}
                ]
              </span>
            </div>
          )}
          ListboxProps={{
            style: {
              maxHeight: 200, // Maximum height for the dropdown
              fontSize: "15px", // Font size for options
            },
          }}
          renderInput={params => (
            <TextField
              {...params}
              style={{ fontSize: "82%" }}
              name="searchManagerName"
              id="searchManagerName"
              label="Manager Name/Email" // Input label
            />
          )}
          label="Manager Name/Email" // Input label
        />
      ))
  );
}

// Prop type validation for the component
AgentSearchChip.propTypes = {
  tableData: PropTypes.object, // Data for the table
  values: PropTypes.string, // Selected value
  getAgentByHierarchy: PropTypes.func, // Function to fetch agents by hierarchy
  onChange: PropTypes.func, // Change handler
  label: PropTypes.string, // Label for the input
  clearSearchManagerName: PropTypes.func, // Function to clear the search manager name
};

// Mapping state to props
const mapStateToProps = app => ({
  tableData: app.provideRegistration, // Data from the provide registration reducer
  merchantData: app.merchantInformation, // Data from the merchant information reducer
});

// Connecting the component to the Redux store
export default connect(mapStateToProps, {
  getAgentByHierarchy,
})(AgentSearchChip);
